<template>
  <div>
    <v-app-bar
      flat
      color="custom-toolbar"
      app
      clipped-left
      height="110"
      class="px-5"
    >
      <v-avatar size="110" tile class="mx-5">
        <v-img src="@/assets/logo-bmp-moneyplus.png" width="100%" contain />
      </v-avatar>
      <v-card
        v-if="!isMobile"
        color="#284775"
        outlined
        class="d-flex flex-column px-4 py-2"
      >
        <div class="d-flex justify-space-between align-center">
          <span class="muli-semibold h3 mr-1" style="color: #ffcb34"
            >Saldo disponível</span
          >
          <v-btn @click="changeIcon" small icon color="#F2F2F2" class="ml-3">
            <v-icon style="font-size: 15px">
              {{ amountIcon }}
            </v-icon>
          </v-btn>
        </div>
        <span v-if="showAmount" class="muli-bold h2" style="color: #f2f2f2">{{
          amount
        }}</span>
        <div
          v-if="!showAmount"
          style="color: #f2f2f2"
          class="muli-bold h2"
          width="100px"
          height="100px"
        >
          R$ {{ hiddenAmount }}
        </div>
      </v-card>
      <v-spacer></v-spacer>
      <div v-if="!isMobile">
        <router-link to="/atividade" class="text-decoration-none">
          <v-btn
            large
            depressed
            color="primary"
            class="mr-2 text-capitalize muli-bold h3"
            style="color: #f2f2f2"
          >
            <v-icon left color="#F2F2F2"> fa fa-list </v-icon>
            Atividade
          </v-btn>
        </router-link>

        <v-btn
          @click="changePass"
          large
          depressed
          color="primary"
          class="mr-5 text-capitalize muli-bold h3"
          style="color: #f2f2f2"
        >
          <v-icon left color="#F2F2F2"> fa fa-exchange-alt </v-icon>
          Trocar Senha
        </v-btn>

        <v-btn
          @click="logout"
          large
          depressed
          color="primary"
          class="mr-5 text-capitalize muli-bold h3"
          style="color: #f2f2f2"
        >
          <v-icon left color="#F2F2F2"> fa fa-sign-out-alt </v-icon>
          Sair
        </v-btn>
      </div>
      <div v-if="isMobile">
        <v-dialog max-width="300">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon color="#F2F2F2" class="mr-2" v-bind="attrs" v-on="on">
              <v-icon> fa fa-wallet </v-icon>
            </v-btn>
          </template>
          <v-card color="#284775">
            <v-card-title class="text-center muli-bold h3">
              <span class="muli-regular h3" style="color: #ffcb34">
                Saldo disponível
              </span>
            </v-card-title>
            <v-card-text>
              <span class="muli-semibold h2" style="color: #f2f2f2">
                {{ amount }}
              </span>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-btn icon color="#F2F2F2" @click.stop="drawer = !drawer">
          <v-icon> fa fa-bars </v-icon>
        </v-btn>
      </div>
    </v-app-bar>
    <v-navigation-drawer
      style="background: #284775"
      v-model="drawer"
      absolute
      temporary
    >
      <v-list nav dense>
        <v-list-item-group>
          <router-link to="/atividade" class="text-decoration-none">
            <v-list-item class="pa-2">
              <v-list-item-title class="muli-bold h3" style="color: #f2f2f2">
                Atividade
              </v-list-item-title>
              <v-list-item-icon>
                <v-icon color="#F2F2F2"> fa fa-list </v-icon>
              </v-list-item-icon>
            </v-list-item>
          </router-link>

          <v-list-item @click="changePass" class="pa-2">
            <v-list-item-title class="muli-bold h3" style="color: #f2f2f2">
              Trocar Senha
            </v-list-item-title>
            <v-list-item-icon>
              <v-icon color="#F2F2F2"> fa fa-exchange-alt </v-icon>
            </v-list-item-icon>
          </v-list-item>

          <v-list-item @click="logout" class="pa-2">
            <v-list-item-title class="muli-bold h3" style="color: #f2f2f2">
              Sair
            </v-list-item-title>
            <v-list-item-icon>
              <v-icon color="#F2F2F2"> fa fa-sign-out-alt </v-icon>
            </v-list-item-icon>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
export default {
  data: () => ({
    drawer: false,
    showAmount: true,
    amountIcon: "fa fa-eye",
    hiddenAmount: "",
    userIdentificador: "",
  }),
  methods: {
    changeIcon() {
      const th = this;
      th.showAmount = !th.showAmount;
      th.hiddenAmount = "";
      if (th.showAmount) {
        th.amountIcon = "fa fa-eye";
      } else {
        th.amountIcon = "fa fa-eye-slash";
        for (var i = 0; i < th.amount.length - 3; i++) th.hiddenAmount += "–";
      }
    },
    logout() {
      let th = this;
      th.$mgr.signOut().then(
        (signIn) => {
          if (signIn) {
            th.$router.push({ path: th.$store.getters.initialRoute });
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    changePass() {
      window.location.replace(`${process.env.VUE_APP_ROOT_SSO_CHANGEPASSWORD}?clientId=${process.env.VUE_APP_ROOT_SSO_CLIENT_ID}&url=${window.location.origin}`);
    },
  },
  computed: {
    isMobile: {
      get() {
        return this.$store.getters.isMobile;
      },
    },
    amount: {
      get() {
        return this.$api.UI.Format.Currency(
          this.$store.getters["bmpag/balance"].toString()
        );
      },
    },
  },
  mounted() {
    if (JSON.parse(localStorage.getItem("user"))) {
      this.userIdentificador = JSON.parse(
        localStorage.getItem("user")
      ).identificador;
    }
  },
};
</script>
